(function () {
  document.querySelectorAll('.tov-hero-section').forEach(function (section) {
    var sectionId = section.dataset.sectionId;
    var track   = document.getElementById('hero-slides-track-' + sectionId);
    var prevBtn = document.getElementById('hero-prev-' + sectionId);
    var nextBtn = document.getElementById('hero-next-' + sectionId);
    if (!track) return;

    var slides  = track.querySelectorAll('.hero-slide');
    var total   = slides.length;
    if (total <= 1) return;

    var current = 0;

    function goTo(index, instant) {
      if (instant) {
        /* Jump without animation (used when wrapping from last → first) */
        track.style.transition = 'none';
        track.style.transform  = 'translateX(-' + (index * 100) + '%)';
        track.offsetWidth;      /* force reflow so transition:none takes effect */
        track.style.transition  = '';
      } else {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
      }
      current = index;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
    }

    /* Auto-advance — restarted fresh on every manual interaction */
    var INTERVAL = 5000;
    var autoplayTimer = null;

    function startAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(function () {
        if (current >= total - 1) {
          goTo(0, true);
        } else {
          goTo(current + 1);
        }
      }, INTERVAL);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (current > 0) { goTo(current - 1); startAutoplay(); }
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (current < total - 1) { goTo(current + 1); startAutoplay(); }
    });

    /* Touch swipe — also resets autoplay */
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && current < total - 1) goTo(current + 1);
        else if (diff < 0 && current > 0)    goTo(current - 1);
        startAutoplay();
      }
    });

    goTo(0);
    startAutoplay();
  });
})();
